<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="4"
                    :total="4" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "blitz",
            currentTrivia: 14,
            questions: {
                question: {
                    "title": "What data do we use to select the days, times, and stores for a blitz?",
                    "answers": [
                        {"key": "A", "answer": "MAPM opinion on which stores are likely to be hit"},
                        {"key": "B", "answer": "Operational analysis performed by TOMS"},
                        {"key": "C", "answer": "All data points contained in the THD case management system"},
                        {"key": "D", "answer": "Intelligence gained from RDO walks over the last week"}
                    ],
                    "correctAnswer": ["C"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">

</style>
